<template>
<div class="success" :style="{'min-height':height+'px'}">
  <PrivateHeader></PrivateHeader>
  <img src="~pic/success.png" />
  <p>恭喜您，报名成功</p>
  <p>报名成功后，您可以选择线下缴费</p>
  <div>
    <router-link :to="{ name:'Point' }">申请学分</router-link>
    <router-link :to="{ name:'Invoice' }">申请发票</router-link>
    <!-- <router-link to="addPaperInfo">提交论文</router-link> -->
  </div>
  <router-link to="main" class="btn">返回首页</router-link>
</div>
</template>

<script>
import PrivateHeader from '../../components/Headers/header2'
export default {
  components: {
    PrivateHeader
  },
  data() {
    return {
      height: 0,
    }
  },
  mounted() {
    this.height = document.documentElement.clientHeight
  }
}
</script>

<style lang="stylus" scoped>
.success
  background: #F8F8F8
  position: relative
  text-align: center
  padding-top: 2.88rem
  > p
    font-size: .36rem
    font-weight: bold
    color: rgba(51,51,51,1)
    margin-top: .6rem
    &+p
      font-size: .24rem
      font-weight: normal
      color: #666666
      margin-top: .2rem
  > div
    margin-top: .6rem
    a
      color: #E12222
      font-size: .32rem
      &+a
        margin-left: .48rem
  .btn
    position: absolute
    bottom: .6rem
    left: 0
    width: calc(100% - 1.6rem)
    margin: 0 .8rem
    background: rgba(225,34,34,1)
    border-radius:  .1rem
    font-size: .32rem
    font-weight: bold
    color: rgba(255,255,255,1)
    line-height: .88rem
</style>
